module.exports = "/assets/restaurant-photo@2x.png?NBi86RF";